<template>
  <div>
    <div>
      <div class="table-responsive">
        <table cellpadding="1" cellspacing="1" class="table no-margins">
          <thead>
          <tr>
            <th class="">Last name</th>
            <th class="">First name</th>
            <th class="">Document</th>
            <th class="">
              <table cellpadding="1" cellspacing="1" class="table table-condensed table-striped" style="margin-bottom: 0">
                <thead>
                <th width="33%">Affiliation</th>
                <th width="33%">Email</th>
                <th width="33%">Status</th>
                </thead>
              </table>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-if="experts" v-for="(expert, key) in experts" :key="key">
            <td>{{expert.lastName}}</td>
            <td>{{expert.firstName}}</td>
            <td><a v-if="expert.doc" @click="showDocument(expert.doc)">{{expert.doc.title}}</a></td>
            <td>
              <table cellpadding="1" cellspacing="1" class="table table-condensed" style="margin-bottom: 0">
                <tbody>
                <tr v-if="expert.author_organisations.length !== 0 && affiliation.email"
                    v-for="(affiliation, key) in expert.author_organisations" :key="key + '-' + affiliation.selected">
                  <td width="33%" :style="{borderTop: key === 0 ? '0' : '1px solid #ddd'}">
                    {{ (typeof affiliation.organisation === 'undefined' ? '' : affiliation.organisation.organisationName) }}
                  </td>
                  <td width="33%" :style="{borderTop: key === 0 ? '0' : '1px solid #ddd'}">
                    {{affiliation.email}}
                  </td>
                  <td width="33%" :style="{borderTop: key === 0 ? '0' : '1px solid #ddd'}">
                    <div class="">
                      <div class="col-xs-2">
                        <div title="sent mails">
                          <i style="" class="fa fa-send"></i>
                          <template v-if="eventsExperts[affiliation.email]">{{eventsExperts[affiliation.email].nb_sent}}</template>
                          <template v-else>0</template>
                        </div>
                      </div>
                      <div class="col-xs-2">
                        <div title="Opened">
                          <i class="fa fa-envelope-open"></i>
                          <template v-if="eventsExperts[affiliation.email]">{{eventsExperts[affiliation.email].nb_open}}</template>
                          <template v-else>0</template>
                        </div>
                      </div>
                      <div class="col-xs-2">
                        <div title="Clicked">
                          <i class="fa fa-hand-o-down"></i>
                          <template v-if="eventsExperts[affiliation.email]">{{eventsExperts[affiliation.email].nb_click}}</template>
                          <template v-else>0</template>
                        </div>
                      </div>
                      <div class="col-xs-2">
                        <div title="Bounced">
                          <i class="fa fa-undo"></i>
                          <template v-if="eventsExperts[affiliation.email]">{{eventsExperts[affiliation.email].nb_bounce}}</template>
                          <template v-else>0</template>
                        </div>
                      </div>
                      <div class="col-xs-2">
                        <div title="Spam">
                          <i class="fa fa-exclamation-circle"></i>
                          <template v-if="eventsExperts[affiliation.email]">{{eventsExperts[affiliation.email].nb_blocked}}</template>
                          <template v-else>0</template>
                        </div>
                      </div>
                    </div>

                  </td>
                </tr>
                </tbody>

              </table>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="modal fade " id="modalShowDocument" tabindex="-1" role="dialog"  aria-hidden="true">
      <div v-if="documentToShow" class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="color-line"></div>
          <div class="modal-header">
            <h4 class="modal-title">{{documentToShow.title}}</h4>
          </div>
          <div class="modal-body">
            <div v-html="documentToShow.abstract"></div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal" >Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<style scoped>
</style>

<script>
import VueLadda from 'vue-ladda'

export default {
  components: {VueLadda},
  props: ['experts', 'eventsExperts'],
  name: 'ExpertsContacted',
  mounted () {
    $('#modalShowDocument').on('hidden.bs.modal', (e) => {
      this.documentToShow = null
    })
  },
  data () {
    return {
      documentToShow: null
    }
  },
  methods: {
    showDocument: function (doc) {
      this.documentToShow = doc
    },
    selectAll: function (e) {
      this.experts.forEach((expert) => {
        if (expert.author_organisations.length !== 0) {
          expert.author_organisations = expert.author_organisations.map((affiliation) => {
            affiliation.selected = e.target.checked
            return affiliation
          })
        }
      })
    }
  },
  watch: {
    documentToShow: function (doc) {
      if (doc !== null) {
        $('#modalShowDocument').modal('show')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mailing/ExpertsContacted.vue